import React from 'react'
import '../../assets/css/VidTutorials.css';

const VideoTutCard = (props) => {
  return (
    <div className='vid_tuts_card'>
        <iframe className='iframe_vid' src={"https://www.youtube.com/embed/"+props.link}></iframe>
        <div className='overlap' onClick={()=>props.playVid(props.link)}></div>
        <p className='text-black fw-bold'>{props.title}</p>
    </div>
  )
}

export default VideoTutCard